import { TextField } from "@mui/material";
import { NewCommentButton, NewCommentInputContainer } from "./incidentSummary.styled";
import { useContext, useEffect, useState } from "react";
import CommentDetail, { CommentDetailProps } from "./commentDetail";
import { UserClaims, AuthContext } from "core/contexts/auth/auth";
import { getIncidentComments, postUserComment } from "modules/flywheel/services/incidentService";
import { convertUnixTimeToDate } from  "core/utils/dateTimeUtils";
import {  v4 as uuidv4 } from 'uuid';
import { useTheme } from "styled-components";


export interface IncidentCommentsProps {
    t: any;
    theme: any;
    user: UserClaims | null;
    incidentId: string;
    initialComments: CommentDetailProps[];
}

export default function IncidentComments({t, theme, user, incidentId, initialComments}: IncidentCommentsProps) {
    const [ comments, setComments ] = useState(initialComments);
    const [ localIncidentid, setlLocalIncidentId ] = useState(incidentId);
    const { checkAFToken } = useContext(AuthContext)
    const [ commentText, setCommentText ] = useState('');

    useEffect(() => {
        setComments(initialComments)
        setlLocalIncidentId(incidentId)
    }, [initialComments, incidentId])

    /**
    * Fetch new comments every X seconds and replace the current list
    */
    useEffect(() => {
        const fetchComments = async () => {
            const token = await checkAFToken();
            const config = { 'Authorization': token || '', 'Content-Type': 'application/json' };
            const response = await getIncidentComments(config, incidentId);
            if (response) {
                setComments(() => ([
                    ...response
                ]))
            }
        };
    
        // const intervalId = setInterval(fetchComments, 30000);
        // return () => clearInterval(intervalId);

        // This will never trigger more than once after it has been filled
    }, [localIncidentid])

    /**
     * Manage the comments, the summary modal will periodically poll for new comments from other users
     * @param comments 
     */
    const addComment = (commentText, timeNow) => {
        setComments((current: any) => ([
            { 
                commentId: uuidv4(),
                firstName: user?.given_name || '',
                lastName: user?.family_name || '',
                userEmail: user?.email || '',
                postedOn: convertUnixTimeToDate(timeNow),
                commentText: commentText,
                image: user?.image || ''
            },
            ...current
        ]))
    };

    /**
     * Add the comment to the backend
     */
    async function handleSubmitComment() {
        const token = await checkAFToken();
        const config = { 'Authorization': token || '', 'Content-Type': 'application/json' };
        const timeNow = Date.now();

        const response = await postUserComment(
            config,
            [{
                userEmail: user?.email,
                postedOn: timeNow,
                commentText: commentText
            }],
            incidentId
        );

        if (response) {
            setCommentText('');
            addComment(commentText, timeNow);
        }
    }

    return(
        <>
            <strong className="pb-2" style={{fontSize: theme.font.large}}>{t("INCIDENTS_PAGE.COMMENTS")}:</strong>
            <NewCommentInputContainer>
                <TextField  
                    id="outlined-textarea"
                    placeholder={t("INCIDENTS_PAGE.ADD_COMMENT") || "Add a comment"}
                    multiline
                    value={commentText}
                    onChange={(event) => setCommentText(event.target.value)}
                    className="w-100"
                    style={{fontSize: theme.font.medium}}
                />
                <NewCommentButton variant="outlined" onClick={handleSubmitComment} disabled={commentText === "" ? true : false}>
                    <p>{t("INCIDENTS_PAGE.SUBMIT_COMMENT")}</p>
                </NewCommentButton>
            </NewCommentInputContainer>
            {comments.map((comment, index) => {
                if (comment.firstName) {
                    return (
                        <CommentDetail
                            key={`${comment.commentId}`}
                            initialsColor={'#006666'}
                            firstName={comment.firstName}
                            lastName={comment.lastName}
                            userEmail={comment.userEmail}
                            postedOn={comment.postedOn}
                            commentText={comment.commentText}
                        />
                    );
                } else {
                    return(<></>)
                }
            })}
        </>
    )
}